import {
  addDays,
  listActiveEventType,
  addVenueEvent,
  getVenueEvent,
  updateVenueEvent,
  updateVenueEventStatus,
  listDays,
  statusUpdate,
  updateDays,
  venueAdd,
  venueList,
  venueStatusDelete,
  venueStatusUpdate,
  venueUpdate,
  signIn,
  addAvatars,
  listAvatars,
  updateAvatars,
  deleteAvatars,
  listAi,
  addAi,
  updateAi,
  deleteAi,
  listRating,
  addRating,
  updateRating,
  deleteRating,
  mediaVenue,
  mediaVenueAdd,
  mediaVenueUpdate,
  mediaVenueStatus,
  mediaVenueDelete,
  reviewVenue,
  reviewVenueUpdate,
  // reviewVenueAdd,
  reviewVenueStatus,
  reviewVenueDelete,
  reviewVenueStarAdmin,
  reviewVenueStarAdminAdd,
  reviewVenueStarAdminUpdate,
  sendClaimMediaMessage,
  claimMessageEdit,
  claimMessageDelete,
  mediaVenueUser,
  reviewVenueStarList,
  venuePreferences,
  venuePreferencesAdd,
  venuePreferencesUpdate,
  userList,
  changePass,
  userPreferences,
  venueUploadedPhotos,
  userCheckedInHistory,
  userUploadedVenuePhotos,
  CurrentKids,
  CurrentKidsUpdate,
  userLoginHistory,
  userFriend,
  CurrentKidsAdd,
  userFriendCount,
  futureKidsList,
  futureKidsUpdate,
  futureKidsAdd,
  drinkingList,
  drinkingUpdate,
  drinkingAdd,
  smokeUpdate,
  smokeAdd,
  smokeList,
  educationAdd,
  educationList,
  educationUpdate,
  qualityList,
  qualityAdd,
  qualityUpdate,
  relationList,
  relationAdd,
  relationUpdate,
  hobbiesList,
  hobbiesAdd,
  hobbiesUpdate,
  manList,
  manAdd,
  manUpdate,
  womanList,
  womanAdd,
  womanUpdate,
  binaryList,
  binaryAdd,
  binaryUpdate,
  datingProfile,
  claimMediaApprove,
  RatingListData,
  unrecognizedAi,
  genderList,
  genderAdd,
  genderUpdate,
  datListExercise,
  addDatExercise,
  updateDatExercise,
  venuesCheckInOut,
  getClaimedVenueList,
  claimedVenueUpdateStatus,
  claimMediaListVenue,
  mediMediaSubList,
  listReason,
  addReason,
  updateReason,
  getClaimedChat,
  datingFriendList,
  venueSaveSlots,
  venueGetSlots,
  addQuickSurveyCategory,
  listQuickSurveyCategory,
  updateQuickSurveyCategory,
  deleteQuickSurveyCategory,
  addQuickSurveyQuestions,
  listQuickSurveyQuestions,
  updateQuickSurveyQuestions,
  categoryWiseQuestion,
  addVenueQuestion,
  getVenueQuestion,
  getSurveyAnswersByVenue,
  getUserSearchHistory,
  listVenueSaveReason,
  addVenueSaveReason,
  updateVenueSaveReason,
  loucaCoinList,
  loucaCoinSetting,
  userCoinEarnHistory,
  analyticsUserSaveVenue,
  analyticsUserFunnelVenue,
  userCoinReferEarnHistory,
  getUserReferralHistory,
  getOverallSummary,
  getDashboardGraph,
  getSentimentTrackingAi,
  getLiveDemoGraphGraph,
  getLiveFootTraffic,
  listProfileTypes,
  addProfileTypes,
  updateProfileTypes,
  deleteProfileTypes,
  createPublicUser,
  listEventTypes,
  addEventTypes,
  updateEventTypes,
  deleteEventTypes,
  activeProfileTypes,
  userCheckInOutLogs,
  eventMediaAdd,
  getEventWiseMedia,
  deleteEVentMedia,
  userProfileMediaAdd,
  userProfileMediaDelete,
  userProfileMediaGet,
  getFollowingList,
  getFollowerList,
  publicUserUpdate,
  sentVenueInvite,
  recivedVenueInvite,
  pronounsList,
  pronounsAdd,
  pronounsUpdate,
  occupationsList,
  occupationsAdd,
  occupationsUpdate,
  ageGroupList,
  ageGroupAdd,
  ageGroupUpdate,
  hairColorList,
  hairColorAdd,
  hairColorUpdate,
  heightList,
  heightAdd,
  heightUpdate,
  bodyTypeList,
  bodyTypeAdd,
  bodyTypeUpdate,
  sharedFeed,
  sharedFeedUserList,
  getCategoryScore,
  getRepeatVisitor,
  getVenueUserIntent,
  getLocalAreaTrends,
  getEventVsNormalNight,
  getVenueTopKeyWords,
  getTimeOfDay,
  saveLegalContent,
  getLegalContent,
  deleteUserAccount,
  restoreUserAccount,
  getCountryStateCity,
  daysStatus,
  listPrefAgeGroup,
  addPrefAgeGroup,
  updatePrefAgeGroup,
  statusPrefAgeGroup,
  listAlcohol,
  addAlcohol,
  updateAlcohol,
  statusAlcohol,
  listCraving,
  addCraving,
  updateCraving,
  statusCraving,
  listCrowds,
  addCrowds,
  updateCrowds,
  statusCrowds,
  listCuisine,
  addCuisine,
  updateCuisine,
  statusCuisine,
  listDietary,
  addDietary,
  updateDietary,
  statusDietary,
  listDJClubs,
  addDJClubs,
  updateDJClubs,
  statusDJClubs,
  listEntryFees,
  addEntryFees,
  updateEntryFees,
  statusEntryFees,
  listEventActivities,
  addEventActivities,
  updateEventActivities,
  statusEventActivities,
  listFoodPrice,
  addFoodPrice,
  updateFoodPrice,
  statusFoodPrice,
  listLiveMusic,
  addLiveMusic,
  updateLiveMusic,
  statusLiveMusic,
  listNonAlcohol,
  addNonAlcohol,
  updateNonAlcohol,
  statusNonAlcohol,
  listRegions,
  addRegions,
  updateRegions,
  statusRegions,
  listSpecials,
  addSpecials,
  updateSpecials,
  statusSpecials,
  listVenueTags,
  addVenueTags,
  updateVenueTags,
  statusVenueTags,
  getPreferencesMasterData,
  listIntrestedIn,
  addIntrestedIn,
  updateIntrestedIn,
  statusIntrestedIn,
  listRelationshipStatus,
  addRelationshipStatus,
  updateRelationshipStatus,
  statusRelationshipStatus,
  venueInterestedDateWiseList,
  signInVenue,
  createVenueOwner,
  sendOtpEmail,
  verifyOtp,
  getVenueBased,
  saveVenueDocument,
  getVenueOwnerList,
  venueAssignByAdmin,
  venueUnAssignByAdmin,
  getVenueListOfOwner,
  getOverAllSummeryForVenueOwner,
  getDashboardGraphForVenueOwner,
  nightPrefrenceAdd,
  nightPrefrenceList,
  nightPrefrenceUpdate,
} from "./ApiEndPoint";
import { baseApiCall } from "./BaseApiCall";

export const apiCallSignIn = (data: any) => {
  return baseApiCall({
    url: signIn,
    method: "post",
    data,
  });
};

export const apiCallChangePass = (data: any) => {
  return baseApiCall({
    url: changePass,
    method: "post",
    data,
  });
};

export const apiCallVenueList = (data: any) => {
  return baseApiCall({
    url: venueList,
    method: "post",
    data,
  });
};

export const apiCallStatusUpdate = (data: any) => {
  return baseApiCall({
    url: statusUpdate,
    method: "post",
    data,
  });
};


export const apiCallReasonList = (data: any) => {
  return baseApiCall({
    url: listReason,
    method: "post",
    data,
  });
};

export const apiCallVenueSaveReasonList = (data: any) => {
  return baseApiCall({
    url: listVenueSaveReason,
    method: "post",
    data,
  });
};

export const apiCallVenueSaveReasonAdd = (data: any) => {
  return baseApiCall({
    url: addVenueSaveReason,
    method: "post",
    data,
  });
};

export const apiCallVenueSaveReasonUpdate = (data: any) => {
  return baseApiCall({
    url: updateVenueSaveReason,
    method: "post",
    data,
  });
};

export const apiCallEventTypeList = (data: any) => {
  return baseApiCall({
    url: listEventTypes,
    method: "get",
    data,
  });
};

export const apiCallEventTypeAdd = (data: any) => {
  return baseApiCall({
    url: addEventTypes,
    method: "post",
    data,
  });
};

export const apiCallEventTypeUpdate = (data: any) => {
  return baseApiCall({
    url: updateEventTypes,
    method: "put",
    data,
  });
};

export const apiCallEventTypeDelete = (data: any) => {
  return baseApiCall({
    url: deleteEventTypes,
    method: "put",
    data,
  });
};

export const apiCallProfileTypeList = (data: any) => {
  return baseApiCall({
    url: listProfileTypes,
    method: "get",
    data,
  });
};

export const apiCallActiveProfileTypeList = (data: any) => {
  return baseApiCall({
    url: activeProfileTypes,
    method: "get",
    data,
  });
};

export const apiCallProfileTypeAdd = (data: any) => {
  return baseApiCall({
    url: addProfileTypes,
    method: "post",
    data,
  });
};

export const apiCallProfileTypeUpdate = (data: any) => {
  return baseApiCall({
    url: updateProfileTypes,
    method: "put",
    data,
  });
};

export const apiCallUserProfileMediaAdd = (data: any) => {
  return baseApiCall({
    url: userProfileMediaAdd,
    method: "post",
    data,
  });
};

export const apiCallUserProfileMediaDelete = (data: any) => {
  return baseApiCall({
    url: userProfileMediaDelete,
    method: "post",
    data,
  });
};

export const apiCallUserProfileMediaGet = (data: any) => {
  return baseApiCall({
    url: userProfileMediaGet,
    method: "post",
    data,
  });
};

export const apiCallProfileTypeDelete = (data: any) => {
  return baseApiCall({
    url: deleteProfileTypes,
    method: "put",
    data,
  });
};

export const apiCallCreatePublicUser = (data: any) => {
  return baseApiCall({
    url: createPublicUser,
    method: "post",
    data,
  });
};

export const apiCallUserUpdate = (data: any) => {
  return baseApiCall({
    url: publicUserUpdate,
    method: "post",
    data,
  });
};

export const apiCallLoucaCoinList = (data: any) => {
  return baseApiCall({
    url: loucaCoinList,
    method: "post",
    data,
  });
};
export const apiCallLoucaCoinSettings = (data: any) => {
  return baseApiCall({
    url: loucaCoinSetting,
    method: "post",
    data,
  });
};


export const apiCallReasonAdd = (data: any) => {
  return baseApiCall({
    url: addReason,
    method: "post",
    data,
  });
};

export const apiCallReasonUpdate = (data: any) => {
  return baseApiCall({
    url: updateReason,
    method: "post",
    data,
  });
};



export const apiCallDatExerciseList = (data: any) => {
  return baseApiCall({
    url: datListExercise,
    method: "get",
    data,
  });
};

export const apiCallDatExerciseAdd = (data: any) => {
  return baseApiCall({
    url: addDatExercise,
    method: "post",
    data,
  });
};

export const apiCallDatExerciseUpdate = (data: any) => {
  return baseApiCall({
    url: updateDatExercise,
    method: "post",
    data,
  });
};



export const apiCallVenueStatusUpdate = (data: any) => {
  return baseApiCall({
    url: venueStatusUpdate,
    method: "post",
    data,
  });
};

export const apiCallVenueStatusDelete = (data: any) => {
  return baseApiCall({
    url: venueStatusDelete,
    method: "post",
    data,
  });
};

export const apiCallVenueUpdate = (data: any) => {
  return baseApiCall({
    url: venueUpdate,
    method: "post",
    data,
  });
};

export const apiCallVenueAdd = (data: any) => {
  return baseApiCall({
    url: venueAdd,
    method: "post",
    data,
  });
};

export const apiCallAvatarsList = (data: any) => {
  return baseApiCall({
    url: listAvatars,
    method: "get",
    data,
  });
};

export const apiCallAvatarsAdd = (data: any) => {
  return baseApiCall({
    url: addAvatars,
    method: "post",
    data,
  });
};

export const apiCallAvatarsUpdate = (data: any) => {
  return baseApiCall({
    url: updateAvatars,
    method: "post",
    data,
  });
};

export const apiCallAvatarsDelete = (data: any) => {
  return baseApiCall({
    url: deleteAvatars,
    method: "post",
    data,
  });
};

export const apiCallAiList = (data: any) => {
  return baseApiCall({
    url: listAi,
    method: "get",
    data,
  });
};

export const apiCallAiAdd = (data: any) => {
  return baseApiCall({
    url: addAi,
    method: "post",
    data,
  });
};

export const apiCallAiUpdate = (data: any) => {
  return baseApiCall({
    url: updateAi,
    method: "post",
    data,
  });
};

export const apiCallAiDelete = (data: any) => {
  return baseApiCall({
    url: deleteAi,
    method: "post",
    data,
  });
};

export const apiCallRatingList = (data: any) => {
  return baseApiCall({
    url: listRating,
    method: "get",
    data,
  });
};

export const apiCallRatingListData = (data: any) => {
  return baseApiCall({
    url: RatingListData,
    method: "get",
    data,
  });
};

export const apiCallQuickSurveyAdd = (data: any) => {
  return baseApiCall({
    url: addQuickSurveyCategory,
    method: "post",
    data,
  });
};

export const apiCallQuickSurveyCategoryList = (data: any) => {
  return baseApiCall({
    url: listQuickSurveyCategory,
    method: "post",
    data,
  });
};

export const apiCallQuickSurveyUpdate = (data: any) => {
  return baseApiCall({
    url: updateQuickSurveyCategory,
    method: "post",
    data,
  });
};

export const apiCallQuickSurveyDelete = (data: any) => {
  return baseApiCall({
    url: deleteQuickSurveyCategory,
    method: "post",
    data,
  });
};

export const apiCallQuickSurveyQuestionsAdd = (data: any) => {
  return baseApiCall({
    url: addQuickSurveyQuestions,
    method: "post",
    data,
  });
};
export const apiCallQuickSurveyQuestionsList = (data: any) => {
  return baseApiCall({
    url: listQuickSurveyQuestions,
    method: "post",
    data,
  });
};
export const apiCallQuickSurveyQuestionsUpdate = (data: any) => {
  return baseApiCall({
    url: updateQuickSurveyQuestions,
    method: "post",
    data,
  });
};
export const apiCallCategoryWiseQuestion = (data: any) => {
  return baseApiCall({
    url: categoryWiseQuestion,
    method: "post",
    data,
  });
};
export const apiCallAddVenueSurveySelection = (data: any) => {
  return baseApiCall({
    url: addVenueQuestion,
    method: "post",
    data,
  });
};
export const apiCallGetVenueQuestion = (data: any) => {
  return baseApiCall({
    url: getVenueQuestion,
    method: "post",
    data,
  });
};
export const apiCallGetSurveyAnswersByVenue = (data: any) => {
  return baseApiCall({
    url: getSurveyAnswersByVenue,
    method: "post",
    data,
  });
};

export const apiCallRatingAdd = (data: any) => {
  return baseApiCall({
    url: addRating,
    method: "post",
    data,
  });
};

export const apiCallRatingUpdate = (data: any) => {
  return baseApiCall({
    url: updateRating,
    method: "post",
    data,
  });
};

export const apiCallRatingDelete = (data: any) => {
  return baseApiCall({
    url: deleteRating,
    method: "post",
    data,
  });
};
export const apiCallMediaVenue = (data: any) => {
  return baseApiCall({
    url: mediaVenue,
    method: "post",
    data,
  });
};
export const apiCallMediaVenueAdd = (data: any) => {
  return baseApiCall({
    url: mediaVenueAdd,
    method: "post",
    data,
  });
};
export const apiCallEventMediaAdd = (data: any) => {
  return baseApiCall({
    url: eventMediaAdd,
    method: "post",
    data,
  });
};

export const apiCallMediaVenueUpdate = (data: any) => {
  return baseApiCall({
    url: mediaVenueUpdate,
    method: "post",
    data,
  });
};
export const apiCallMediaVenueStatus = (data: any) => {
  return baseApiCall({
    url: mediaVenueStatus,
    method: "post",
    data,
  });
};

export const apiCallDeleteMedia = (data: any) => {
  return baseApiCall({
    url: mediaVenueDelete,
    method: "post",
    data,
  });
};

export const apiCallVenueReviews = (data: any) => {
  return baseApiCall({
    url: reviewVenue,
    method: "post",
    data,
  });
};

export const apiCallVenueReviewsUpdate = (data: any) => {
  return baseApiCall({
    url: reviewVenueUpdate,
    method: "post",
    data,
  });
};

// export const apiCallVenueReviewsAdd = (data: any) => {
//   return baseApiCall({
//     url: reviewVenueAdd,
//     method: 'post',
//     data
//   })
// }

export const apiCallVenueReviewsDelete = (data: any) => {
  return baseApiCall({
    url: reviewVenueDelete,
    method: "post",
    data,
  });
};

export const apiCallVenueReviewsStatus = (data: any) => {
  return baseApiCall({
    url: reviewVenueStatus,
    method: "post",
    data,
  });
};

export const apiCallVenueStarAdmin = (data: any) => {
  return baseApiCall({
    url: reviewVenueStarAdmin,
    method: "post",
    data,
  });
};

export const apiCallVenueStarAdminAdd = (data: any) => {
  return baseApiCall({
    url: reviewVenueStarAdminAdd,
    method: "post",
    data,
  });
};

export const apiCallVenueStarAdminUpdate = (data: any) => {
  return baseApiCall({
    url: reviewVenueStarAdminUpdate,
    method: "post",
    data,
  });
};

export const apiCallGetClaimedChat = (data: any) => {
  return baseApiCall({
    url: getClaimedChat,
    method: "post",
    data,
  });
};

export const apiCallSendClaimChat = (data: any) => {
  return baseApiCall({
    url: sendClaimMediaMessage,
    method: "post",
    data,
  });
};

export const apiCallClaimMessageEdit = (data: any) => {
  return baseApiCall({
    url: claimMessageEdit,
    method: "post",
    data,
  });
};

export const apiCallClaimMessageDelete = (data: any) => {
  return baseApiCall({
    url: claimMessageDelete,
    method: "post",
    data,
  });
};
export const apiCallClaimedVenueUpdateStatus = (data: any) => {
  return baseApiCall({
    url: claimedVenueUpdateStatus,
    method: "post",
    data,
  });
};

export const apiCallClaimMediaApprove = (data: any) => {
  return baseApiCall({
    url: claimMediaApprove,
    method: "post",
    data,
  });
};

export const apiCallMediaVenueUser = (data: any) => {
  return baseApiCall({
    url: mediaVenueUser,
    method: "post",
    data,
  });
};

export const apiCallVenueSaveSlots = (data: any) => {
  return baseApiCall({
    url: venueSaveSlots,
    method: "post",
    data,
  });
};
export const apiCallVenueGetSlots = (data: any) => {
  return baseApiCall({
    url: venueGetSlots,
    method: "post",
    data,
  });
};

export const apiCallReviewVenueStarList = (data: any) => {
  return baseApiCall({
    url: reviewVenueStarList,
    method: "post",
    data,
  });
};

export const apiCallVenuePreferences = (data: any) => {
  return baseApiCall({
    url: venuePreferences,
    method: "post",
    data,
  });
};

export const apiCallVenuePreferencesAdd = (data: any) => {
  return baseApiCall({
    url: venuePreferencesAdd,
    method: "post",
    data,
  });
};

export const apiCallVenuePreferencesUpdate = (data: any) => {
  return baseApiCall({
    url: venuePreferencesUpdate,
    method: "post",
    data,
  });
};

export const apiCallUserList = (data: any) => {
  return baseApiCall({
    url: userList,
    method: "post",
    data,
  });
};

export const apiCallUserPreferences = (data: any) => {
  return baseApiCall({
    url: userPreferences,
    method: "post",
    data,
  });
};

export const apiCallUserUploadedPhotos = (data: any) => {
  return baseApiCall({
    url: venueUploadedPhotos,
    method: "post",
    data,
  });
};

export const apiCallUserUploadedVenuePhotos = (data: any) => {
  return baseApiCall({
    url: userUploadedVenuePhotos,
    method: "post",
    data,
  });
};

export const apiCallUserCheckedInHistory = (data: any) => {
  return baseApiCall({
    url: userCheckedInHistory,
    method: "post",
    data,
  });
};
export const apiAnalyticsUserSaveVenue = (data: any) => {
  return baseApiCall({
    url: analyticsUserSaveVenue,
    method: "post",
    data,
  });
};
export const apiCallGetOverallSummary = (data: any) => {
  return baseApiCall({
    url: getOverallSummary,
    method: "post",
    data,
  });
};
export const apiCallGetLiveDemoGraphGraph = (data: any) => {
  return baseApiCall({
    url: getLiveDemoGraphGraph,
    method: "post",
    data,
  });
};
export const apiCallGetLiveFootTraffic = (data: any) => {
  return baseApiCall({
    url: getLiveFootTraffic,
    method: "post",
    data,
  });
};

export const apiCallgetCategoryScore = (data: any) => {
  return baseApiCall({
    url: getCategoryScore,
    method: "post",
    data,
  });
};

export const apiCallGetVenueUserIntentAnalytics = (data: any) => {
  return baseApiCall({
    url: getVenueUserIntent,
    method: "post",
    data,
  });
};

export const apiCallGetVenueTopKeyWords = (data: any) => {
  return baseApiCall({
    url: getVenueTopKeyWords,
    method: "post",
    data,
  });
};

export const apiCallGetEventVsNormalNight = (data: any) => {
  return baseApiCall({
    url: getEventVsNormalNight,
    method: "post", data,
  });
};

export const apiCallGetRepeatVisitorAnalytics = (data: any) => {
  return baseApiCall({
    url: getRepeatVisitor,
    method: "post",
    data,
  });
};

export const apiCallGetLocalAreaTrends = (data: any) => {
  return baseApiCall({
    url: getLocalAreaTrends,
    method: "post",
    data,
  });
};

export const apiCallGetTimeOfDay = (data: any) => {
  return baseApiCall({
    url: getTimeOfDay,
    method: "post",
    data,
  });
};



export const apiCallSentimentTrackingAi = (data: any) => {
  return baseApiCall({
    url: getSentimentTrackingAi,
    method: "post",
    data,
  });
};
export const apiCallGetDashboardGraph = (data: any) => {
  return baseApiCall({
    url: getDashboardGraph,
    method: "post",
    data,
  });
};
export const apiAnalyticsUserFunnelVenue = (data: any) => {
  return baseApiCall({
    url: analyticsUserFunnelVenue,
    method: "post",
    data,
  });
};

export const apiCallUserCoinEarnHistory = (data: any) => {
  return baseApiCall({
    url: userCoinEarnHistory,
    method: "post",
    data,
  });
};
export const apiCallUserReferCoinEarnHistory = (data: any) => {
  return baseApiCall({
    url: userCoinReferEarnHistory,
    method: "post",
    data,
  });
};
export const apiCallGetUserReferralHistory = (data: any) => {
  return baseApiCall({
    url: getUserReferralHistory,
    method: "post",
    data,
  });
};

export const apiCallUserCheckInOutLogs = (data: any) => {
  return baseApiCall({
    url: userCheckInOutLogs,
    method: "post",
    data,
  });
};

export const apiCallUserLoginHistory = (data: any) => {
  return baseApiCall({
    url: userLoginHistory,
    method: "post",
    data,
  });
};
export const apiCallUserSearchHistory = (data: any) => {
  return baseApiCall({
    url: getUserSearchHistory,
    method: "post",
    data,
  });
};

export const apiCallUserFriend = (data: any) => {
  return baseApiCall({
    url: userFriend,
    method: "post",
    data,
  });
};

export const apiCallSharedFeed = (data: any) => {
  return baseApiCall({
    url: sharedFeed,
    method: "post",
    data,
  });
};

export const apiCallSharedFeedUserList = (data: any) => {
  return baseApiCall({
    url: sharedFeedUserList,
    method: "post",
    data,
  });
};


export const apiCallDatingFriendList = (data: any) => {
  return baseApiCall({
    url: datingFriendList,
    method: "post",
    data,
  });
};

export const apiCallSentVenueInvite = (data: any) => {
  return baseApiCall({
    url: sentVenueInvite,
    method: "post",
    data,
  });
};

export const apiCallRecivedVenueInvite = (data: any) => {
  return baseApiCall({
    url: recivedVenueInvite,
    method: "post",
    data,
  });
};

export const apiCallFriendList = (data: any) => {
  return baseApiCall({
    url: userFriendCount,
    method: "post",
    data,
  });
};

export const apiCallListPronouns = (data: any) => {
  return baseApiCall({
    url: pronounsList,
    method: "get",
    data,
  });
};

export const apiCallListOccupations = (data: any) => {
  return baseApiCall({
    url: occupationsList,
    method: "get",
    data,
  });
};

export const apiCallCurrentKids = (data: any) => {
  return baseApiCall({
    url: CurrentKids,
    method: "get",
    data,
  });
};

export const apiCallCurrentKidsAdd = (data: any) => {
  return baseApiCall({
    url: CurrentKidsAdd,
    method: "post",
    data,
  });
};
export const apiCallPronounsAdd = (data: any) => {
  return baseApiCall({
    url: pronounsAdd,
    method: "post",
    data,
  });
};

export const apiCallOccupationsAdd = (data: any) => {
  return baseApiCall({
    url: occupationsAdd,
    method: "post",
    data,
  });
};

export const apiCallCurrentKidsUpdate = (data: any) => {
  return baseApiCall({
    url: CurrentKidsUpdate,
    method: "post",
    data,
  });
};
export const apiCallPronounsUpdate = (data: any) => {
  return baseApiCall({
    url: pronounsUpdate,
    method: "post",
    data,
  });
};

export const apiCallOccupationsUpdate = (data: any) => {
  return baseApiCall({
    url: occupationsUpdate,
    method: "post",
    data,
  });
};

export const apiCallFutureKidsList = (data: any) => {
  return baseApiCall({
    url: futureKidsList,
    method: "get",
    data,
  });
};

export const apiCallFutureKidsUpdate = (data: any) => {
  return baseApiCall({
    url: futureKidsUpdate,
    method: "post",
    data,
  });
};

export const apiCallFutureKidsAdd = (data: any) => {
  return baseApiCall({
    url: futureKidsAdd,
    method: "post",
    data,
  });
};

export const apiCallDrinkingList = (data: any) => {
  return baseApiCall({
    url: drinkingList,
    method: "get",
    data,
  });
};

export const apiCallDrinkingUpdate = (data: any) => {
  return baseApiCall({
    url: drinkingUpdate,
    method: "post",
    data,
  });
};

export const apiCallDrinkingAdd = (data: any) => {
  return baseApiCall({
    url: drinkingAdd,
    method: "post",
    data,
  });
};

export const apiCallSmokeList = (data: any) => {
  return baseApiCall({
    url: smokeList,
    method: "get",
    data,
  });
};

export const apiCallSmokeAdd = (data: any) => {
  return baseApiCall({
    url: smokeAdd,
    method: "post",
    data,
  });
};

export const apiCallSmokeUpdate = (data: any) => {
  return baseApiCall({
    url: smokeUpdate,
    method: "post",
    data,
  });
};

export const apiCallEducationList = (data: any) => {
  return baseApiCall({
    url: educationList,
    method: "get",
    data,
  });
};

export const apiCallEducationAdd = (data: any) => {
  return baseApiCall({
    url: educationAdd,
    method: "post",
    data,
  });
};

export const apiCallEducationUpdate = (data: any) => {
  return baseApiCall({
    url: educationUpdate,
    method: "post",
    data,
  });
};

export const apiCallEqualityList = (data: any) => {
  return baseApiCall({
    url: qualityList,
    method: "get",
    data,
  });
};

export const apiCallEQualityAdd = (data: any) => {
  return baseApiCall({
    url: qualityAdd,
    method: "post",
    data,
  });
};

export const apiCallEqualityUpdate = (data: any) => {
  return baseApiCall({
    url: qualityUpdate,
    method: "post",
    data,
  });
};

export const apiCallRelationList = (data: any) => {
  return baseApiCall({
    url: relationList,
    method: "get",
    data,
  });
};

export const apiCallRelationAdd = (data: any) => {
  return baseApiCall({
    url: relationAdd,
    method: "post",
    data,
  });
};

export const apiCallRelationUpdate = (data: any) => {
  return baseApiCall({
    url: relationUpdate,
    method: "post",
    data,
  });
};

export const apiCallHobbiesList = (data: any) => {
  return baseApiCall({
    url: hobbiesList,
    method: "get",
    data,
  });
};

export const apiCallHobbiesAdd = (data: any) => {
  return baseApiCall({
    url: hobbiesAdd,
    method: "post",
    data,
  });
};

export const apiCallHobbiesUpdate = (data: any) => {
  return baseApiCall({
    url: hobbiesUpdate,
    method: "post",
    data,
  });
};

export const apiCallNightPrefrenceAdd = (data: any) => {
  return baseApiCall({
    url: nightPrefrenceAdd,
    method: "post",
    data,
  });
};

export const apiCallNightPrefrenceList = (data: any) => {
  return baseApiCall({
    url: nightPrefrenceList,
    method: "get",
    data,
  });
};

export const apiCallNightPrefrenceUpdate = (data: any) => {
  return baseApiCall({
    url: nightPrefrenceUpdate,
    method: "post",
    data,
  });
};


export const apiCallManList = (data: any) => {
  return baseApiCall({
    url: manList,
    method: "get",
    data,
  });
};

export const apiCallManAdd = (data: any) => {
  return baseApiCall({
    url: manAdd,
    method: "post",
    data,
  });
};

export const apiCallManUpdate = (data: any) => {
  return baseApiCall({
    url: manUpdate,
    method: "post",
    data,
  });
};

export const apiCallWomanList = (data: any) => {
  return baseApiCall({
    url: womanList,
    method: "get",
    data,
  });
};

export const apiCallWomanAdd = (data: any) => {
  return baseApiCall({
    url: womanAdd,
    method: "post",
    data,
  });
};

export const apiCallWomanUpdate = (data: any) => {
  return baseApiCall({
    url: womanUpdate,
    method: "post",
    data,
  });
};

export const apiCallNonBinaryList = (data: any) => {
  return baseApiCall({
    url: binaryList,
    method: "get",
    data,
  });
};

export const apiCallNonBinaryAdd = (data: any) => {
  return baseApiCall({
    url: binaryAdd,
    method: "post",
    data,
  });
};

export const apiCallNonBinaryUpdate = (data: any) => {
  return baseApiCall({
    url: binaryUpdate,
    method: "post",
    data,
  });
};

export const apiCallDatingProfile = (data: any) => {
  return baseApiCall({
    url: datingProfile,
    method: "post",
    data,
  });
};

export const apiCallUnrecognizedAi = (data: any) => {
  return baseApiCall({
    url: unrecognizedAi,
    method: "post",
    data,
  });
};

export const apiCallGenderList = (data: any) => {
  return baseApiCall({
    url: genderList,
    method: "get",
    data,
  });
};

export const apiCallGenderAdd = (data: any) => {
  return baseApiCall({
    url: genderAdd,
    method: "post",
    data,
  });
};

export const apiCallGenderUpdate = (data: any) => {
  return baseApiCall({
    url: genderUpdate,
    method: "post",
    data,
  });
};

export const apiCallVenuesCheckInOut = (data: any) => {
  return baseApiCall({
    url: venuesCheckInOut,
    method: "post",
    data,
  });
};
export const apiCallVenueInterestedDateWise = (data: any) => {
  return baseApiCall({
    url: venueInterestedDateWiseList,
    method: "post",
    data,
  });
};

export const apiCallGetClaimedVenueList = (data: any) => {
  return baseApiCall({
    url: getClaimedVenueList,
    method: "post",
    data,
  });
};

export const apiClaimMediaListVenue = (data: any) => {
  return baseApiCall({
    url: claimMediaListVenue,
    method: "post",
    data,
  });
};

export const postMediMediaSubList = (data: any) => {
  return baseApiCall({
    url: mediMediaSubList,
    method: "post",
    data,
  });
};

export const apiCallActiveEventTypes = (data: any) => {
  return baseApiCall({
    url: listActiveEventType,
    method: "get",
    data,
  });
};

export const apiCallAddVenueEvent = (data: any) => {
  return baseApiCall({
    url: addVenueEvent,
    method: "post",
    data,
  });
};
export const apiCallVenueEvent = (data: any) => {
  return baseApiCall({
    url: getVenueEvent,
    method: "post",
    data,
  });
};
export const apiCallUpdateVenueEvent = (data: any) => {
  return baseApiCall({
    url: updateVenueEvent,
    method: "post",
    data,
  });
};

export const apiCallEventStatusChange = (data: any) => {
  return baseApiCall({
    url: updateVenueEventStatus,
    method: "post",
    data,
  });
};

export const apiCallGetEventWiseMedia = (data: any) => {
  return baseApiCall({
    url: getEventWiseMedia,
    method: "post",
    data,
  });
};

export const apiCallDeleteEventMedia = (data: any) => {
  return baseApiCall({
    url: deleteEVentMedia,
    method: "post",
    data,
  });
};

export const apiCallFollowingList = (data: any) => {
  return baseApiCall({
    url: getFollowingList,
    method: "post",
    data,
  });
};

export const apiCallFollowerList = (data: any) => {
  return baseApiCall({
    url: getFollowerList,
    method: "post",
    data,
  });
};

export const apiCallListAgeGroup = (data: any) => {
  return baseApiCall({
    url: ageGroupList,
    method: "get",
    data,
  });
};

export const apiCallAgeGroupAdd = (data: any) => {
  return baseApiCall({
    url: ageGroupAdd,
    method: "post",
    data,
  });
};

export const apiCallAgeGroupUpdate = (data: any) => {
  return baseApiCall({
    url: ageGroupUpdate,
    method: "post",
    data,
  });
};

export const apiCallListHairColor = (data: any) => {
  return baseApiCall({
    url: hairColorList,
    method: "get",
    data,
  });
};

export const apiCallAddHairColor = (data: any) => {
  return baseApiCall({
    url: hairColorAdd,
    method: "post",
    data,
  });
};

export const apiCallUpdateHairColor = (data: any) => {
  return baseApiCall({
    url: hairColorUpdate,
    method: "post",
    data,
  });
};

export const apiCallListHeight = (data: any) => {
  return baseApiCall({
    url: heightList,
    method: "get",
    data,
  });
};

export const apiCallAddHeight = (data: any) => {
  return baseApiCall({
    url: heightAdd,
    method: "post",
    data,
  });
};

export const apiCallUpdateHeight = (data: any) => {
  return baseApiCall({
    url: heightUpdate,
    method: "post",
    data,
  });
};

export const apiCallListBodyType = (data: any) => {
  return baseApiCall({
    url: bodyTypeList,
    method: "get",
    data,
  });
};

export const apiCallAddBodyType = (data: any) => {
  return baseApiCall({
    url: bodyTypeAdd,
    method: "post",
    data,
  });
};

export const apiCallUpdateBodyType = (data: any) => {
  return baseApiCall({
    url: bodyTypeUpdate,
    method: "post",
    data,
  });
};


export const apiCallSaveLegalContent = (data: any) => {
  return baseApiCall({
    url: saveLegalContent,
    method: "post",
    data,
  });
};

export const apiCallGetLegalContent = (data: any) => {
  return baseApiCall({
    url: getLegalContent,
    method: "post",
    data,
  });
};


export const apicallDeteleUserAccount = (data: any) => {
  return baseApiCall({
    url: deleteUserAccount,
    method: "post",
    data,
  });
};

export const apiCallRestoreAccount = (data: any) => {
  return baseApiCall({
    url: restoreUserAccount,
    method: "post",
    data,
  });
};


export const apiCallGetLocaitonList = () => {
  return baseApiCall({
    url: getCountryStateCity,
    method: "post",
  });
};

export const apiCallGetVenueListOfOwner = () => {
  return baseApiCall({
    url: getVenueListOfOwner,
    method: "post",
  });
};

export const apiCallGetOverAllSummeryForVenueOwner = (data: any) => {
  return baseApiCall({
    url: getOverAllSummeryForVenueOwner,
    method: "post",
    data
  });
};

export const apiCallGetDashboardGraphForVenueOwner = (data: any) => {
  return baseApiCall({
    url: getDashboardGraphForVenueOwner,
    method: "post",
    data
  });
};



/////preferences

export const apiCallDaysList = (data: any) => {
  return baseApiCall({
    url: listDays,
    method: "get",
    data,
  });
};

export const apiCallDaysAdd = (data: any) => {
  return baseApiCall({
    url: addDays,
    method: "post",
    data,
  });
};

export const apiCallDayUpdate = (data: any) => {
  return baseApiCall({
    url: updateDays,
    method: "post",
    data,
  });
};

export const apiCallDayStatus = (data: any) => {
  return baseApiCall({
    url: daysStatus,
    method: "post",
    data,
  });
};





export const apiCallPrefAgeGroupList = (data: any) => {
  return baseApiCall({
    url: listPrefAgeGroup,
    method: "get",
    data,
  });
};

export const apiCallPrefAgeGroupAdd = (data: any) => {
  return baseApiCall({
    url: addPrefAgeGroup,
    method: "post",
    data,
  });
};

export const apiCallPrefAgeGroupUpdate = (data: any) => {
  return baseApiCall({
    url: updatePrefAgeGroup,
    method: "post",
    data,
  });
};

export const apiCallPrefAgeGroupStatus = (data: any) => {
  return baseApiCall({
    url: statusPrefAgeGroup,
    method: "post",
    data,
  });
};



export const apiCallAlcoholList = (data: any) => {
  return baseApiCall({
    url: listAlcohol,
    method: "get",
    data,
  });
};

export const apiCallAlcoholAdd = (data: any) => {
  return baseApiCall({
    url: addAlcohol,
    method: "post",
    data,
  });
};

export const apiCallAlcoholUpdate = (data: any) => {
  return baseApiCall({
    url: updateAlcohol,
    method: "post",
    data,
  });
};

export const apiCallAlcoholStatus = (data: any) => {
  return baseApiCall({
    url: statusAlcohol,
    method: "post",
    data,
  });
};






export const apiCallCravingList = (data: any) => {
  return baseApiCall({
    url: listCraving,
    method: "get",
    data,
  });
};

export const apiCallCravingAdd = (data: any) => {
  return baseApiCall({
    url: addCraving,
    method: "post",
    data,
  });
};

export const apiCallCravingUpdate = (data: any) => {
  return baseApiCall({
    url: updateCraving,
    method: "post",
    data,
  });
};

export const apiCallCravingStatus = (data: any) => {
  return baseApiCall({
    url: statusCraving,
    method: "post",
    data,
  });
};





export const apiCallCrowdsList = (data: any) => {
  return baseApiCall({
    url: listCrowds,
    method: "get",
    data,
  });
};

export const apiCallCrowdsAdd = (data: any) => {
  return baseApiCall({
    url: addCrowds,
    method: "post",
    data,
  });
};

export const apiCallCrowdsUpdate = (data: any) => {
  return baseApiCall({
    url: updateCrowds,
    method: "post",
    data,
  });
};

export const apiCallCrowdsStatus = (data: any) => {
  return baseApiCall({
    url: statusCrowds,
    method: "post",
    data,
  });
};















export const apiCallCuisineList = (data: any) => {
  return baseApiCall({
    url: listCuisine,
    method: "get",
    data,
  });
};

export const apiCallCuisineAdd = (data: any) => {
  return baseApiCall({
    url: addCuisine,
    method: "post",
    data,
  });
};

export const apiCallCuisineUpdate = (data: any) => {
  return baseApiCall({
    url: updateCuisine,
    method: "post",
    data,
  });
};

export const apiCallCuisineStatus = (data: any) => {
  return baseApiCall({
    url: statusCuisine,
    method: "post",
    data,
  });
};















export const apiCallDietaryList = (data: any) => {
  return baseApiCall({
    url: listDietary,
    method: "get",
    data,
  });
};

export const apiCallDietaryAdd = (data: any) => {
  return baseApiCall({
    url: addDietary,
    method: "post",
    data,
  });
};

export const apiCallDietaryUpdate = (data: any) => {
  return baseApiCall({
    url: updateDietary,
    method: "post",
    data,
  });
};

export const apiCallDietaryStatus = (data: any) => {
  return baseApiCall({
    url: statusDietary,
    method: "post",
    data,
  });
};

















export const apiCallDJClubList = (data: any) => {
  return baseApiCall({
    url: listDJClubs,
    method: "get",
    data,
  });
};

export const apiCallDJClubAdd = (data: any) => {
  return baseApiCall({
    url: addDJClubs,
    method: "post",
    data,
  });
};

export const apiCallDJClubUpdate = (data: any) => {
  return baseApiCall({
    url: updateDJClubs,
    method: "post",
    data,
  });
};

export const apiCallDJClubStatus = (data: any) => {
  return baseApiCall({
    url: statusDJClubs,
    method: "post",
    data,
  });
};

















export const apiCallEntryFeeList = (data: any) => {
  return baseApiCall({
    url: listEntryFees,
    method: "get",
    data,
  });
};

export const apiCallEntryFeeAdd = (data: any) => {
  return baseApiCall({
    url: addEntryFees,
    method: "post",
    data,
  });
};

export const apiCallEntryFeeUpdate = (data: any) => {
  return baseApiCall({
    url: updateEntryFees,
    method: "post",
    data,
  });
};

export const apiCallEntryFeeStatus = (data: any) => {
  return baseApiCall({
    url: statusEntryFees,
    method: "post",
    data,
  });
};


















export const apiCallEventActivitieList = (data: any) => {
  return baseApiCall({
    url: listEventActivities,
    method: "get",
    data,
  });
};

export const apiCallEventActivitieAdd = (data: any) => {
  return baseApiCall({
    url: addEventActivities,
    method: "post",
    data,
  });
};

export const apiCallEventActivitieUpdate = (data: any) => {
  return baseApiCall({
    url: updateEventActivities,
    method: "post",
    data,
  });
};

export const apiCallEventActivitieStatus = (data: any) => {
  return baseApiCall({
    url: statusEventActivities,
    method: "post",
    data,
  });
};


export const apiCallFoodPriceList = (data: any) => {
  return baseApiCall({
    url: listFoodPrice,
    method: "get",
    data,
  });
};

export const apiCallFoodPriceAdd = (data: any) => {
  return baseApiCall({
    url: addFoodPrice,
    method: "post",
    data,
  });
};

export const apiCallFoodPriceUpdate = (data: any) => {
  return baseApiCall({
    url: updateFoodPrice,
    method: "post",
    data,
  });
};

export const apiCallFoodPriceStatus = (data: any) => {
  return baseApiCall({
    url: statusFoodPrice,
    method: "post",
    data,
  });
};








export const apiCallLiveMusicList = (data: any) => {
  return baseApiCall({
    url: listLiveMusic,
    method: "get",
    data,
  });
};

export const apiCallLiveMusicAdd = (data: any) => {
  return baseApiCall({
    url: addLiveMusic,
    method: "post",
    data,
  });
};

export const apiCallLiveMusicUpdate = (data: any) => {
  return baseApiCall({
    url: updateLiveMusic,
    method: "post",
    data,
  });
};

export const apiCallLiveMusicStatus = (data: any) => {
  return baseApiCall({
    url: statusLiveMusic,
    method: "post",
    data,
  });
};









export const apiCallNonAlcoholList = (data: any) => {
  return baseApiCall({
    url: listNonAlcohol,
    method: "get",
    data,
  });
};

export const apiCallNonAlcoholAdd = (data: any) => {
  return baseApiCall({
    url: addNonAlcohol,
    method: "post",
    data,
  });
};

export const apiCallNonAlcoholUpdate = (data: any) => {
  return baseApiCall({
    url: updateNonAlcohol,
    method: "post",
    data,
  });
};

export const apiCallNonAlcoholStatus = (data: any) => {
  return baseApiCall({
    url: statusNonAlcohol,
    method: "post",
    data,
  });
};

















export const apiCallRegionList = (data: any) => {
  return baseApiCall({
    url: listRegions,
    method: "get",
    data,
  });
};

export const apiCallRegionAdd = (data: any) => {
  return baseApiCall({
    url: addRegions,
    method: "post",
    data,
  });
};

export const apiCallRegionUpdate = (data: any) => {
  return baseApiCall({
    url: updateRegions,
    method: "post",
    data,
  });
};

export const apiCallRegionStatus = (data: any) => {
  return baseApiCall({
    url: statusRegions,
    method: "post",
    data,
  });
};
















export const apiCallSpecialList = (data: any) => {
  return baseApiCall({
    url: listSpecials,
    method: "get",
    data,
  });
};

export const apiCallSpecialAdd = (data: any) => {
  return baseApiCall({
    url: addSpecials,
    method: "post",
    data,
  });
};

export const apiCallSpecialUpdate = (data: any) => {
  return baseApiCall({
    url: updateSpecials,
    method: "post",
    data,
  });
};

export const apiCallSpecialStatus = (data: any) => {
  return baseApiCall({
    url: statusSpecials,
    method: "post",
    data,
  });
};



















export const apiCallVenueTagList = (data: any) => {
  return baseApiCall({
    url: listVenueTags,
    method: "get",
    data,
  });
};

export const apiCallVenueTagAdd = (data: any) => {
  return baseApiCall({
    url: addVenueTags,
    method: "post",
    data,
  });
};

export const apiCallVenueTagUpdate = (data: any) => {
  return baseApiCall({
    url: updateVenueTags,
    method: "post",
    data,
  });
};

export const apiCallVenueTagStatus = (data: any) => {
  return baseApiCall({
    url: statusVenueTags,
    method: "post",
    data,
  });
};
export const apiCallGetPreferencesMasterData = (data: any) => {
  return baseApiCall({
    url: getPreferencesMasterData,
    method: "post",
    data,
  });
};























export const apiCallIntrestedInList = (data: any) => {
  return baseApiCall({
    url: listIntrestedIn,
    method: "get",
    data,
  });
};

export const apiCallIntrestedInAdd = (data: any) => {
  return baseApiCall({
    url: addIntrestedIn,
    method: "post",
    data,
  });
};

export const apiCallIntrestedInUpdate = (data: any) => {
  return baseApiCall({
    url: updateIntrestedIn,
    method: "post",
    data,
  });
};

export const apiCallIntrestedInStatus = (data: any) => {
  return baseApiCall({
    url: statusIntrestedIn,
    method: "post",
    data,
  });
};






















export const apiCallRelationshipStatusList = (data: any) => {
  return baseApiCall({
    url: listRelationshipStatus,
    method: "get",
    data,
  });
};

export const apiCallRelationshipStatusAdd = (data: any) => {
  return baseApiCall({
    url: addRelationshipStatus,
    method: "post",
    data,
  });
};

export const apiCallRelationshipStatusUpdate = (data: any) => {
  return baseApiCall({
    url: updateRelationshipStatus,
    method: "post",
    data,
  });
};

export const apiCallRelationshipStatusStatus = (data: any) => {
  return baseApiCall({
    url: statusRelationshipStatus,
    method: "post",
    data,
  });
};


export const postApiSignInVenue = (data: any) => {
  return baseApiCall({
    url: signInVenue,
    method: 'post',
    data
  })
}


export const postApiCreateVenueOwner = (data: any) => {
  return baseApiCall({
    url: createVenueOwner,
    method: 'post',
    data
  })
}


export const postApiSendOtpEmail = (data: any) => {
  return baseApiCall({
    url: sendOtpEmail,
    method: 'post',
    data
  })
}

export const postApiVerifyOtp = (data: any) => {
  return baseApiCall({
    url: verifyOtp,
    method: 'post',
    data
  })
}


export const postApiVenueBased = (data: any) => {
  return baseApiCall({
    url: getVenueBased,
    method: 'post',
    data
  })
}

export const postSaveVenueDocument = (data: any) => {
  return baseApiCall({
    url: saveVenueDocument,
    method: 'post',
    data
  })
}

export const postGetVenueOwnerList = (data: any) => {
  return baseApiCall({
    url: getVenueOwnerList,
    method: 'post',
    data
  })
}
export const postApiCallVenueAssignByAdmin = (data: any) => {
  return baseApiCall({
    url: venueAssignByAdmin,
    method: 'post',
    data
  })
}
export const postApiCallVenueUnassignByAdmin = (data: any) => {
  return baseApiCall({
    url: venueUnAssignByAdmin,
    method: 'post',
    data
  })
}
